import React from 'react';
import {t} from 'i18next';
import {getAppendedClassWithDevice} from "../../../../shared/utils/deviceUtils";
import './OpeningHours.scss';

interface OpeningHoursProp {
    isMobile?: boolean;
}

export const OpeningHours = (prop: OpeningHoursProp = {
    isMobile: false
}) => {
    return (
        <div className={getAppendedClassWithDevice('opening-hours-wrapper', prop.isMobile)}>
            <div className={getAppendedClassWithDevice('opening-hours-container', prop.isMobile)}>
                <div className="text-uppercase fw-bold">{t('OpeningHours')}</div>
                <div className="day-container">
                    <div>{t('FromMondayToFriday')}:</div>
                    <div>07:00 - 17:00</div>
                </div>
                <div className="day-container">
                    <div>{t('Saturday')}:</div>
                    <div>07:00 - 12:00</div>
                </div>
                <div className="day-container">
                    <div>{t('Sunday')}:</div>
                    <div>{t('Closed')}</div>
                </div>
            </div>
        </div>
    );
};
